import { TCreateModifierGroupsAction, CreateModifierGroupsActionTypes } from './createModifierGroupsActions';
import { ICreateModifierGroupsState } from './createModifierGroupsContext';

export const createModifierGroupsReducer = (
	state: ICreateModifierGroupsState,
	action: TCreateModifierGroupsAction,
): ICreateModifierGroupsState => {
	switch (action.type) {
		case CreateModifierGroupsActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
				fetchedRestaurants: [],
			};
		case CreateModifierGroupsActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
			};
		case CreateModifierGroupsActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case CreateModifierGroupsActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case CreateModifierGroupsActionTypes.CHANGE_NAME_OF_MODIFIER_GROUP:
			return {
				...state,
				nameOfModifierGroup: action.payload.nameOfModifierGroup,
			};
		case CreateModifierGroupsActionTypes.CHANGE_EXTERNAL_ID:
			return {
				...state,
				externalId: action.payload.externalId,
			};
		case CreateModifierGroupsActionTypes.SET_FETCHED_TRANSLATIONS:
			return {
				...state,
				translations: action.payload.translations,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case CreateModifierGroupsActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case CreateModifierGroupsActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case CreateModifierGroupsActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateModifierGroupsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateModifierGroupsActionTypes.RESET_FIELDS:
			return {
				...state,
				fetchedCustomers: [],
				IDSelectedCustomer: null,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				nameOfModifierGroup: '',
				externalId: '',
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
